import React from 'react';

import Switch from '../../../components/input/Switch';
import Button from '../../../components/Button';
import Anchor from '../../../components/link/Anchor';
import ExcelUploadForm from '../../../components/form/ExcelUploadForm';
import VirtualizedTable from './components/VirtualizedTable';
import useOrderCreateViewModel from './useOrderCreateViewModel';
import usePrompt from '../../../hooks/common/usePrompt';
import { MULTI_CHANNEL_ORDER_UPLOAD_TEMPLATE_XLSX_URL } from '../../../constants/service/common/staticFileUrlConstants';
import { BottomBarStyle, OrderCreateStyle, TableContainerStyle, UploadInfoStyle } from './style';

const OrderCreate = (): JSX.Element => {
  const {
    totalCount,
    possibleCount,
    impossibleCount,
    isImpossibleCountVisible,
    setIsImpossibleCountVisible,
    checkedIdList,
    setCheckedIdList,
    deleteOrderItems,
    createOrder,
    orderList,
    columns,
    uploadExcel,
    tableHeight,
    isCreateOrderActive,
  } = useOrderCreateViewModel();

  usePrompt(totalCount > 0, '멀티채널 주문 생성을 중단하시겠습니까?');

  return (
    <OrderCreateStyle>
      <div className="panel-header">
        <div className="title">업로드 주문 리스트</div>
      </div>
      <div className="panel-body">
        <UploadInfoStyle>
          <div className="upload-count">
            <div className="total-count">총 {totalCount}건 업로드</div>
            <div className="possible-count">
              생성 가능 : <span className="possible-count">{possibleCount}</span>건
            </div>
            <div className="impossible-count">
              생성 불가 : <span className="impossible-count">{impossibleCount}</span>건
            </div>
          </div>
          <div className="upload-controls">
            <div className="impossible-count-toggle">
              <label>생성 불가건 조회</label>
              <Switch
                disabled={totalCount === 0}
                checked={isImpossibleCountVisible}
                onClick={setIsImpossibleCountVisible}
              />
            </div>
            <Button className="delete-button" text="선택 삭제" onClick={deleteOrderItems} />
            <div className="guide-message">모든 업로드건이 '가능' 상태일 때만 생성하기가 가능합니다.</div>
            <div className="button-wrap">
              <Anchor
                text="업로드 템플릿 다운로드"
                isUnderLine
                color="primary"
                href={MULTI_CHANNEL_ORDER_UPLOAD_TEMPLATE_XLSX_URL}
                target="_blank"
              />

              <ExcelUploadForm onChange={uploadExcel} btnText="주문 엑셀 업로드" />
            </div>
          </div>
        </UploadInfoStyle>
        <TableContainerStyle>
          <VirtualizedTable
            width={4499}
            height={tableHeight}
            list={orderList}
            columns={columns}
            checkedIdList={checkedIdList}
            setCheckedIdList={setCheckedIdList}
          />
        </TableContainerStyle>
        <BottomBarStyle>
          <Button disabled={!isCreateOrderActive} color="primary" text="생성하기" onClick={createOrder} />
        </BottomBarStyle>
      </div>
    </OrderCreateStyle>
  );
};
export default OrderCreate;
